export const languageOptions = [
  { label: "English", value: "english" },
  { label: "French", value: "french" },
  { label: "German", value: "german" },
  { label: "Spanish", value: "spanish" },
  { label: "Chinese", value: "chinese" },
  { label: "Arabic", value: "arabic" },
  { label: "Russian", value: "russian" },
  { label: "Portuguese", value: "portuguese" },
  { label: "Swahili", value: "swahili" },
  { label: "Japanese", value: "japanese" },
  { label: "Hindi", value: "hindi" },
  { label: "Italian", value: "italian" },
  { label: "Other", value: "other" },
];

export const availabilityOptions = [
  { label: "Immediately Available", value: "immediately" },
  { label: "Available Within 1 month", value: "within_1_month" },
  { label: "Available Within 3 months", value: "within_3_months" },
  { label: "Contract bound", value: "contract_bound" },
  { label: "Other", value: "other" },
];
const specializations = [
  "Commercial Aviation",
  "General Aviation",
  "Military Aviation",
  "Cargo Operations",
  "Flight Training",
  "Aircraft Maintenance",
  "Air Traffic Control",
  "Airport Operations",
  "Aviation Safety",
  "Aerospace Engineering",
  "Avionics",
  "Flight Operations",
];

export const aviationSpecializations = specializations.map((spec) => ({
  label: spec,
  value: spec,
}));
// Was in experience section in prototype

export const licenseTypeOptions = [
  { label: "Commercial Pilot License (CPL)", value: "cpl" },
  { label: "Airline Transport Pilot License (ATPL)", value: "atpl" },
  { label: "Aircraft Maintenance Engineer (AME)", value: "ame" },
  { label: "Private Pilot License (PPL)", value: "ppl" },
  { label: "Instrument Rating (IR)", value: "ir" },
  { label: "Multi-Engine Rating", value: "me" },
  { label: "Flight Instructor Rating (FI)", value: "fi" },
  { label: "Flight Dispatcher License", value: "dispatcher" },
  { label: "Air Traffic Controller License", value: "atc" },
  { label: "Cabin Crew License", value: "cabin_crew" },
  { label: "Other", value: "other" },
];
// License section - LicenseForm

export const licenseRatingOptions = [
  { label: "Instrument Rating", value: "instrument" },
  { label: "Type Rating", value: "type" },
  { label: "Multi-Engine Rating", value: "multi_engine" },
  { label: "Instructor Rating", value: "instructor" },
  { label: "Night Rating", value: "night" },
  { label: "IFR Rating", value: "ifr" },
  { label: "VFR Rating", value: "vfr" },
  { label: "Other", value: "other" },
];

export const licenseStatuses = [
  { value: "active", label: "Active" },
  { value: "expired", label: "Expired" },
];

export const educationLevelOptions = [
  { label: "Certificate", value: "certificate" },
  { label: "Diploma", value: "diploma" },
  { label: "Degree", value: "degree" },
  { label: "Masters", value: "masters" },
  { label: "PhD", value: "phd" },
  { label: "Other", value: "other" },
];

export const regulatoryBodyOptions = [
  { label: "KCAA", value: "kcaa" },
  { label: "FAA", value: "faa" },
  { label: "EASA", value: "easa" },
  { label: "ICAO", value: "icao" },
  { label: "Other", value: "other" },
];

export const aircraftTypeOptions = [
  { label: "Boeing 737", value: "b737" },
  { label: "Airbus A320", value: "a320" },
  { label: "Embraer 190", value: "e190" },
  { label: "Cessna Caravan", value: "caravan" },
  { label: "ATR 72", value: "atr72" },
  { label: "Other", value: "other" },
];

export const regionOptions = [
  { label: "Africa", value: "africa" },
  { label: "Middle East", value: "middle_east" },
  { label: "Europe", value: "europe" },
  { label: "Asia", value: "asia" },
  { label: "North America", value: "north_america" },
  { label: "South America", value: "south_america" },
  { label: "Australia/Oceania", value: "australia_oceania" },
  { label: "Global", value: "global" },
];

export const organizationTypeOptions = [
  { label: "Airline", value: "airline" },
  { label: "MRO", value: "mro" },
  { label: "Training Institute", value: "training_institute" },
  { label: "Airfield Operators", value: "airfield_operators" },
  { label: "Advocacy Groups", value: "advocacy_groups" },
];

export const aviationCategoryOptions = [
  { label: "Pilot", value: "pilot" },
  { label: "Flight Attendant", value: "flight_attendant" },
  { label: "Engineer", value: "engineer" },
  { label: "Technician", value: "technician" },
  { label: "Air Traffic Controller", value: "atc" },
  { label: "Ground Operations", value: "ground_ops" },
  { label: "Dispatcher", value: "dispatcher" },
  { label: "Other", value: "other" },
];
// Qualification options

export const aviationSpecificationOptions = [
  { value: "cabin_crew", label: "Cabin Crew" },
  { value: "flight_ops", label: "Flight Operations" },
  { value: "maintenance", label: "Maintenance" },
  { value: "pilot", label: "Pilot" },
  { value: "atc", label: "Air Traffic Control" },
  { value: "other", label: "Other" },
];

export const developmentCourseOptions = [
  { value: "safety_management", label: "Safety Management" },
  { value: "aviation_security", label: "Aviation Security" },
  { value: "airport_operations", label: "Airport Operations" },
  {
    value: "aviation_english_proficiency",
    label: "Aviation English Proficiency",
  },
  { value: "human_factors", label: "Human Factors" },
  { value: "other", label: "Other" },
];

export const workshopOptions = [
  { value: "safety_drills", label: "Safety Drills" },
  { value: "emergency_response", label: "Emergency Response" },
  { value: "customer_service", label: "Customer Service" },
  { value: "leadership", label: "Leadership" },
  { value: "other", label: "Other" },
];
export const documentCategories = [
  { key: "cv", label: "Resume / CV" },
  { key: "aviation_licenses", label: "Aviation Licenses" },
  { key: "passport", label: "Passport" },
  { key: "reference_letters", label: "Reference Letters" },
  { key: "logbook", label: "Logbook" },
  { key: "medical_certificate", label: "Medical Certificate" },
  { key: "educational_documents", label: "Educational Documents" },
];

export const icaoLevelChoices = [
  { value: "1", label: "Level 1 - Pre-elementary" },
  { value: "2", label: "Level 2 - Elementary" },
  { value: "3", label: "Level 3 - Pre-operational" },
  { value: "4", label: "Level 4 - Operational" },
  { value: "5", label: "Level 5 - Extended" },
  { value: "6", label: "Level 6 - Expert" },
];

export const issuingAuthorityChoices = [
  { value: "kcaa", label: "KCAA - Kenya Civil Aviation Authority" },
  { value: "faa", label: "FAA - Federal Aviation Administration" },
  { value: "easa", label: "EASA - European Union Aviation Safety Agency" },
  { value: "dgac", label: "DGAC - France / Mexico / Spain / Others" },
  { value: "caac", label: "CAAC - Civil Aviation Administration of China" },
  { value: "tc", label: "Transport Canada - Civil Aviation" },
  { value: "icao_examiner", label: "ICAO-approved language examiner" },
  { value: "other", label: "Other" },
];

export const icaoRecognizedLanguages = [
  { value: "english", label: "English" },
  { value: "french", label: "French" },
  { value: "spanish", label: "Spanish" },
  { value: "russian", label: "Russian" },
  { value: "arabic", label: "Arabic" },
  { value: "chinese", label: "Chinese" },
  { value: "portuguese", label: "Portuguese" },
  { value: "other", label: "Other" },
];
